import React from 'react';
import PropTypes from 'prop-types';

// Sprint 2.4 (Enterprise Design System Foundation): a single, consistent colored badge for every
// status/severity string surfaced by the Sprint 2.2/2.3 backend APIs (health status, governance
// status, payment status, severity levels, etc.) instead of each new page inventing its own colors.
const STATUS_TONE_MAP = {
  healthy: 'success',
  success: 'success',
  approved: 'success',
  used: 'success',
  low: 'success',

  pending: 'warning',
  notchecked: 'warning',
  medium: 'warning',
  aborted: 'warning',

  unhealthy: 'error',
  failed: 'error',
  failure: 'error',
  rejected: 'error',
  error: 'error',
  critical: 'error',
  high: 'error',
  abored: 'error', // legacy misspelling of "Aborted" used by the RazorPay transaction status field

  notconfigured: 'info',
  info: 'info',
  other: 'neutral',
  unknown: 'neutral',
  refunded: 'info'
};

const resolveTone = (status) => {
  if (!status) return 'neutral';
  const key = String(status).toLowerCase().replace(/[^a-z]/g, '');
  return STATUS_TONE_MAP[key] || 'neutral';
};

const StatusBadge = ({ status, tone }) => {
  const resolvedTone = tone || resolveTone(status);
  return (
    <span className={`ent-status-badge ent-status-${resolvedTone}`}>
      <span className="ent-status-dot" aria-hidden="true" />
      {status}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral'])
};

export default StatusBadge;
